import {debugLog} from "../Utils/LogUtils";
import {useEffect} from "react";
import {PLAN_TYPE_IDS} from "../Utils/PlanUtils";

//When the plan type or deposit mode changes, we default the deposit frequency that we'll use for quote generation
// Based on the expected deposit frequency they might be thinking in given the mode they selected
const useUpdateQuoteDefaults = (state) => {
    useEffect(() => {
        if (!state.enrollment.state) { return; }
        let setDepositFrequency = state.quote.depositFrequency;

        if (state.plan.planTypeID === PLAN_TYPE_IDS.ACHIEVERS) {
            //For Achievers, we only allow Lifetime deposit amount for quote generation
            setDepositFrequency = 'T';
        } else {
            //For Group and SI, we can default the frequency selection based on the mode they have chosen
            if (['A','F','Y'].includes(state.plan.depositMode)) {
                setDepositFrequency = 'A';
            } else if (['T'].includes(state.plan.depositMode)) {
                setDepositFrequency = 'T';
            } else {
                //This handles 'M','P','X','S','Q' and any other case
                setDepositFrequency = 'M';
            }
        }
        if (state.quote.depositFrequency !== setDepositFrequency) {
            state.setQuote({
                ...state.quote,
                depositFrequency: setDepositFrequency
            });
        }

        debugLog("useUpdateQuoteDefaults 1");
    }, [state.plan.depositMode, state.plan.planTypeID]);


    useEffect(() => {
        if (!state.enrollment.state) { return; }
        let setDepositFrequency = state.quote.depositFrequency;

        if (state.plan2.planTypeID === PLAN_TYPE_IDS.ACHIEVERS) {
            //For Achievers, we only allow Lifetime deposit amount for quote generation
            setDepositFrequency = 'T';
        } else {
            //For Group and SI, we can default the frequency selection based on the mode they have chosen
            if (['A','F','Y'].includes(state.plan2.depositMode)) {
                setDepositFrequency = 'A';
            } else if (['T'].includes(state.plan2.depositMode)) {
                setDepositFrequency = 'T';
            } else {
                //This handles 'M','P','X','S','Q' and any other case
                setDepositFrequency = 'M';
            }
        }
        if (state.quote2.depositFrequency !== setDepositFrequency) {
            state.setQuote2({
                ...state.quote2,
                depositFrequency: setDepositFrequency
            });
        }

        debugLog("useUpdateQuoteDefaults 1");
    }, [state.plan2.depositMode, state.plan2.planTypeID]);


    //When the plan type changes, we default the deposit mode to Monthly and 1 unit
    // We also force the quote to be based on to deposit for SI and Achievers plans
    // and set the deposit amount to 0 for SI and 465 for Achievers
    // For group, we defualt to project based on units.  For SI and Achievers, we default to deposit.
    useEffect(() => {

        if (state.plan.planTypeID === PLAN_TYPE_IDS.GROUP) {
            state.setQuote(prevData => ({
                ...prevData,
                quoteBasedOn: 'units'
            }));
            state.setPlan(prevData => ({
                ...prevData,
                depositMode: 'M',
                numberOfUnits: 1,
            }));
        }

        if (state.plan.planTypeID === PLAN_TYPE_IDS.SI) {
            state.setQuote(prevData => ({
                ...prevData,
                quoteBasedOn: 'deposit'
            }));
            state.setPlan(prevData => ({
                ...prevData,
                depositMode: 'M',
                numberOfUnits: 1,
                depositAmount: 0,
            }));
        }

        if (state.plan.planTypeID === PLAN_TYPE_IDS.ACHIEVERS) {
            state.setQuote(prevData => ({
                ...prevData,
                quoteBasedOn: 'deposit',
            }));
            /*
            state.setPlan(prevData => ({
                ...prevData,
                depositMode: 'M',
                numberOfUnits: 1,
                depositAmount: 465,
            }));
             */
        }
        debugLog("useUpdateQuoteDefaults 2");
    }, [state.plan.planTypeID]);

    useEffect(() => {

        if (state.plan2.planTypeID === PLAN_TYPE_IDS.GROUP) {
            state.setQuote2(prevData => ({
                ...prevData,
                quoteBasedOn: 'units'
            }));
            state.setPlan2(prevData => ({
                ...prevData,
                depositMode: 'M',
                numberOfUnits: 1,
            }));
        }

        if (state.plan2.planTypeID === PLAN_TYPE_IDS.SI) {
            state.setQuote2(prevData => ({
                ...prevData,
                quoteBasedOn: 'deposit'
            }));
            state.setPlan2(prevData => ({
                ...prevData,
                depositMode: 'M',
                numberOfUnits: 1,
                depositAmount: 0,
            }));
        }

        if (state.plan2.planTypeID === PLAN_TYPE_IDS.ACHIEVERS) {
            state.setQuote2(prevData => ({
                ...prevData,
                quoteBasedOn: 'deposit',
            }));
            /*
            state.setPlan2(prevData => ({
                ...prevData,
                depositMode: 'M',
                numberOfUnits: 1,
                depositAmount: 465,
            }));
             */
        }
        debugLog("useUpdateQuoteDefaults 2");
    }, [state.plan2.planTypeID]);
}

export default useUpdateQuoteDefaults;